import * as React from 'react';
import * as classNames from 'classnames';
import * as dateFormat from 'date-fns/format';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { padStart as _padStart } from 'lodash';
import { IAnyUser } from '../../../../common/interfaces/users';
import { Button, EButtonType } from '../../components/action';
import { StatusIconWithLabel, EStatusIconType } from '../../components/indicator';

// Styles
const s = require('./UsersList.css');
const openArrow = require('./../../assets/open-arrow.svg');

// Props
interface IUsersListUserRowProps {
    onUserEdit: (userId: number) => void;
    user: IAnyUser;
}

// Component
@observer
export class UsersListUserRow extends React.Component<IUsersListUserRowProps, {}> {
    static get defaultProps(): IUsersListUserRowProps {
        return {
            onUserEdit: null,
            user: null
        };
    }

    constructor(props: IUsersListUserRowProps) {
        super(props);
    }

    @computed
    private get userId(): string {
        return this.props.user.id ? _padStart(this.props.user.id.toString(), 2, '0') : '';
    }

    public render() {
        const { user } = this.props;

        return (
            <tr>
                <td className={classNames('text-align-left', s.userId)}>
                    <p>{this.userId}</p>
                </td>

                <td className={classNames('text-align-left', s.userName)}>
                    <p>{user.username}</p>{' '}
                </td>

                <td className={classNames('text-align-left', s.userRealName)}>
                    <p>
                        {user.isCustomer &&
                            user.cardcode && [<strong key="code">{user.cardcode}</strong>, <em key="dash"> — </em>]}
                        <span>{user.name}</span>
                    </p>
                </td>

                <td className={classNames('text-align-right', s.userType)}>
                    <p>{this.props.user.isAdmin ? 'Administrator' : this.props.user.isInternal ? 'Internal' : 'Customer'}</p>
                </td>

                <td className={classNames('text-align-right', s.userLastLogin)}>
                    <p>{user.lastLoggedAt ? dateFormat(user.lastLoggedAt, 'MM/DD/YYYY [at] hh:mm a') : 'Never logged in'}</p>
                </td>

                <td className={classNames('text-align-right', s.userActive)}>
                    <StatusIconWithLabel
                        label={user.isActive ? 'Active' : 'Disabled'}
                        type={user.isActive ? EStatusIconType.Success : EStatusIconType.Dim}
                    />
                </td>

                <td className={classNames('text-align-right', s.userAction)}>
                    <Button onClick={this.handleUserEdit} type={EButtonType.BorderOnly} inBox={true}>
                        Edit
                    </Button>
                </td>
            </tr>
        );
    }

    private handleUserEdit = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (this.props.onUserEdit) {
            this.props.onUserEdit(this.props.user.id);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/admin/UsersListUserRow.tsx